import { View } from 'dripsy';
import * as React from 'react';
import { createPortal } from 'react-dom';
export const Portal = ({ children, position = 'relative', zIndex = '$1', }) => createPortal(React.createElement(View, { sx: { zIndex, position } }, children), document.body);
Portal.displayName = 'Portal';
//# sourceMappingURL=Portal.js.map